export default __webpack_public_path__ + "static/media/CyclesIcon.b16d4ff9.svg";